(() => {
  const mediaQuery = window.matchMedia('(max-width: 640px)');
  const selector = '.template-collection .product-list--collection .product-item__image-wrapper--with-secondary, .template-page [data-section-type="featured-collection"] .product-item__image-wrapper--with-secondary';
  const readyClass = 'gusta-mobile-gallery-ready';
  const secondaryClass = 'gusta-mobile-gallery--secondary';
  const dotActiveClass = 'is-active';

  const updateDots = (link, dots) => {
    const showSecondary = link.classList.contains(secondaryClass);
    dots[0].classList.toggle(dotActiveClass, !showSecondary);
    dots[1].classList.toggle(dotActiveClass, showSecondary);
  };

  const enhance = (link) => {
    if (link.classList.contains(readyClass)) return;

    const primary = link.querySelector('.product-item__primary-image');
    const secondary = link.querySelector('.product-item__secondary-image');
    if (!primary || !secondary) return;

    const indicator = document.createElement('span');
    indicator.className = 'gusta-mobile-gallery-dots';
    indicator.setAttribute('aria-hidden', 'true');

    const dots = [document.createElement('span'), document.createElement('span')];
    dots.forEach((dot) => {
      dot.className = 'gusta-mobile-gallery-dot';
      indicator.appendChild(dot);
    });

    link.appendChild(indicator);
    link.classList.add(readyClass);
    updateDots(link, dots);

    let startX = null;
    let startY = null;
    let suppressNextClick = false;
    let suppressTimer = null;

    link.addEventListener('touchstart', (event) => {
      if (!mediaQuery.matches || event.touches.length !== 1) return;
      const touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
    }, { passive: true });

    link.addEventListener('touchend', (event) => {
      if (!mediaQuery.matches || startX === null || startY === null || event.changedTouches.length === 0) return;

      const touch = event.changedTouches[0];
      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;
      startX = null;
      startY = null;

      const horizontalDistance = Math.abs(deltaX);
      const verticalDistance = Math.abs(deltaY);
      const threshold = Math.min(42, Math.max(28, link.clientWidth * 0.12));

      if (horizontalDistance < threshold || horizontalDistance <= verticalDistance * 1.25) return;

      link.classList.toggle(secondaryClass, deltaX < 0);
      updateDots(link, dots);
      suppressNextClick = true;

      window.clearTimeout(suppressTimer);
      suppressTimer = window.setTimeout(() => {
        suppressNextClick = false;
      }, 300);
    }, { passive: true });

    link.addEventListener('touchcancel', () => {
      startX = null;
      startY = null;
    }, { passive: true });

    link.addEventListener('click', (event) => {
      if (!suppressNextClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressNextClick = false;
    }, true);
  };

  const initialize = (root = document) => {
    root.querySelectorAll(selector).forEach(enhance);
  };

  const start = () => {
    initialize();

    const collectionRoot = document.querySelector('[data-section-type="collection"]') || document.querySelector('main');
    if (!collectionRoot) return;

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(selector)) enhance(node);
          initialize(node);
        });
      });
    });

    observer.observe(collectionRoot, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();